import { string } from 'yup';

export const fieldRequiredSchema = (field: string = 'The field') => string().trim().required(`${field} is required`);
